sv.i18n.util=sv.i18n.util || {};
sv.i18n.util.viewutil=sv.i18n.util.viewutil || {};
sv.i18n.util.viewutil.de={"selectView": "Ansicht auswählen"};
sv.i18n.util.viewutil.en={"selectView": "Select view"};
sv.i18n.util.viewutil.es={"selectView": "Seleccionar vista"};
sv.i18n.util.viewutil.fi={"selectView": "Valitse näkymä"};
sv.i18n.util.viewutil.fr={"selectView": "Sélectionner une vue"};
sv.i18n.util.viewutil.no={"selectView": "Velg visning"};
sv.i18n.util.viewutil.sv={"selectView": "Välj vy"};
